import store from "@/store";

export default {
  created() {
    store.dispatch('breadcrumbs/setBreadcrumbs', [
      {displayName: 'マイページ', path: {name: 'MypageTop', params: ''}},
      {displayName: 'オペレーター', path: {name: 'OperatorTop', params: ''}},
      {displayName: '新規受注・登録時間変更', path: {name: 'UpdatingOperator', params: ''}},
    ])
  },
}